import { useEffect, useState } from "react"

//PrimeReact
import { Badge } from "primereact/badge"
import { Dialog } from "primereact/dialog"
import { Button } from "primereact/button"
import { DataScroller } from "primereact/datascroller"
import { Tooltip } from "primereact/tooltip"
import { ListBox } from "primereact/listbox"
import { Paginator } from "primereact/paginator"

//Style
import refEntityStyles from "../../../../styles/referrals/ReferralEntityForm.module.css"
import mapSearchStyles from "../../../../styles/referrals/ReferralEntityMapSearch.module.css"

import { LoaderMedium } from "../../../../components/Loaders/index"

export default function MapSearchSideBar({
  referralLocations,
  isLoadingLocations,
  onLocate,
  onSelect,
  onNewReferralClick,
  showAllEntities,
  maxDistance,
  ignoreDistance,
  onChangeLocationPage,
}) {
  //const [items, setItems] = useState([])
  const [serviceDialogTitle, setServiceDialogTitle] = useState("")
  const [serviceDialogServices, setServiceDialogServices] = useState([])
  const [scrollHeight, setScrollHeight] = useState("506px")
  const [height, setHeight] = useState("506px")

  const uncategorized = "<Uncategorized>"

  useEffect(() => {
    if (showAllEntities || ignoreDistance) {
      if (referralLocations.numTotal <= referralLocations.pageSize) {
        setScrollHeight("554px")
      } else {
        setScrollHeight("485px")
      }

      setHeight("554px")
    } else {
      if (referralLocations.numTotal <= referralLocations.pageSize) {
        setScrollHeight("506px")
      } else {
        setScrollHeight("437px")
      }

      setHeight("506px")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAllEntities, referralLocations.numTotal])

  function itemTemplate(refLocation) {
    let refEntityStatus = "warning"

    if (refLocation.entityStatus === "confirmed") {
      refEntityStatus = "success"
    } else if (refLocation.entityStatus === "under review") {
      refEntityStatus = "info"
    }

    let cats = uncategorized
    let catFontColorClass = mapSearchStyles.refEntityCategoryColor
    if (
      refLocation.referralCategories &&
      refLocation.referralCategories.length > 0
    ) {
      cats = refLocation.referralCategories.join("; ")
      catFontColorClass = ""
    }

    const fontColor =
      refLocation.distance > maxDistance ? mapSearchStyles.red : ""

    //Generate entity location name and city
    let locationDisplayName = refLocation.name

    if (refLocation.city) {
      locationDisplayName = `${locationDisplayName} (${refLocation.city})`
    }

    return (
      <div className={mapSearchStyles.refEntity}>
        <div className={mapSearchStyles.refEntityDetail}>
          <div className={mapSearchStyles.refEntityName}>
            {refLocation.entityName}
          </div>
          <div className={mapSearchStyles.refEntityLocation}>
            {locationDisplayName}
          </div>
          {!ignoreDistance ? (
            <div
              className={`${mapSearchStyles.refEntityDistance} ${fontColor}`}
            >
              {refLocation.distance > -1
                ? `${refLocation.distance} miles away`
                : ""}
            </div>
          ) : null}

          <div className={mapSearchStyles.refEntityPhone}>
            {refLocation.phone}
          </div>
          <div
            className={`${mapSearchStyles.refEntityCategory} ${catFontColorClass}`}
            style={{ color: catFontColorClass }}
          >
            {cats.length > 100 ? `${cats.substr(0, 97)}...` : cats}
          </div>

          <div className={mapSearchStyles.refEntityBadge}>
            <Tooltip target=".badgeSpan" />
            <span
              className="badgeSpan material-icons"
              data-pr-tooltip={`This is a ${
                !!refLocation.virtual ? "virtual" : "physical"
              } location`}
            >
              {!!refLocation.virtual ? "language" : "house"}
            </span>
            <span
              className="badgeSpan"
              data-pr-tooltip="This status indicates whether a partner has confirmed their account information as correct"
            >
              <Badge
                value={
                  refLocation.entityStatus
                    ? refLocation.entityStatus
                    : "unconfirmed"
                }
                severity={refEntityStatus}
                tooltip="ToolTip"
              />
            </span>
          </div>
        </div>
        <div className={mapSearchStyles.refEntityAction}>
          {!ignoreDistance ? (
            <Button
              label="Locate"
              onClick={() => {
                onLocate(refLocation.locationId)
              }}
              className={`${`${refEntityStyles.button} ${mapSearchStyles.searchSidebarButton}`} ${
                mapSearchStyles.searchSidebarButton
              }`}
              disabled={refLocation.distance === -1}
              tooltip={"Find location on the map"}
            />
          ) : null}

          <Button
            label="Select"
            onClick={() => {
              onSelect(refLocation.locationId)
            }}
            className={`${refEntityStyles.button} ${mapSearchStyles.searchSidebarButton}`}
            tooltip={"Select this partner for the current referral"}
          />
          {cats.length > 100 ? (
            <Button
              label="Services"
              tooltip="Show all services provided"
              onClick={() => {
                setServiceDialogServices(
                  Array.from(new Set(refLocation.referralCategories)).map(
                    (category) => {
                      return { value: category }
                    }
                  )
                )
                setServiceDialogTitle(
                  `Services offered by ${refLocation.entityName}`
                )
              }}
              className={`${`${refEntityStyles.button} ${mapSearchStyles.searchSidebarButton}`} ${
                mapSearchStyles.searchSidebarButton
              }`}
            />
          ) : null}
          {!!refLocation.website ? (
            <Button
              type="button"
              onClick={() => {
                let url = refLocation.website

                if (!!url) {
                  if (!url.includes("http")) {
                    url = `https://${url}`
                  }

                  window.open(url, "_blank", "noopener noreferrer")
                }
              }}
              className={`${refEntityStyles.button} ${mapSearchStyles.searchSidebarButton} ${mapSearchStyles.browseButton} `}
              tooltip={"Browse to website"}
            >
              <span className="material-icons">{"language"}</span>
            </Button>
          ) : null}
        </div>
      </div>
    )
  }

  const footerTemplate = (options) => {
    if (referralLocations.numTotal <= referralLocations.pageSize) {
      return null
    } else {
      return (
        <Paginator
          first={referralLocations.pageSize * (referralLocations.pageNum - 1)}
          rows={referralLocations.pageSize}
          totalRecords={referralLocations.numTotal}
          onPageChange={(e) => {
            onChangeLocationPage(e.page + 1)
          }}
        />
      )
    }
  }

  return (
    <>
      <Dialog
        header={serviceDialogTitle}
        onHide={() => setServiceDialogTitle("")}
        visible={serviceDialogTitle !== ""}
        baseZIndex={1000}
      >
        <div style={{ minHeight: "300" }}>
          <ListBox filter options={serviceDialogServices} optionLabel="value" />
        </div>
      </Dialog>
      <div style={{ height: height }}>
        {isLoadingLocations ? (
          <LoaderMedium />
        ) : (
          <DataScroller
            value={
              !!referralLocations?.locations ? referralLocations?.locations : []
            }
            itemTemplate={itemTemplate}
            rows={
              !!referralLocations?.locations
                ? referralLocations?.locations.length
                : 25
            }
            inline
            scrollHeight={scrollHeight}
            style={{ marginTop: "0" }}
            loader
            footer={footerTemplate()}
          />
        )}
      </div>
      <div
        className={`${mapSearchStyles.newPartner}`}
        style={{ width: "100%" }}
      >
        <Button
          label="New Referral Partner"
          onClick={() => {
            onNewReferralClick()
          }}
          className={`${refEntityStyles.button} ${mapSearchStyles.newPartnerButton}`}
        />
      </div>
    </>
  )
}
